import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import getTitle from '@/utils/getTitle'
import { filterAuthorizedRoutes } from '@/utils/AuthorizedRoutes'
import { isPC } from "@/utils/browser";
import { Message } from 'element-ui' // 引用element-ui的加载和消息提示组件

Vue.use(Router)
import Layout from '@/layout'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


// 全部路由
export const currencyRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: { 'title': '登录页' },
    hidden: true
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/error-page/404.vue'),
    meta: { 'title': '错误页面' },
    hidden: true
  },
  {
    path: '/',
    name: 'Home',
    component: Layout,
    // redirect: '/orders/order',
    redirect: '/login',
    children: [
      {
        path: 'dashbord',
        name: 'Dashbord',
        component: () => import('@/views/welcome/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' },
      },
      {
        path: 'password',
        name: 'Password',
        component: () => import('@/views/password/index.vue'),
        meta: { title: '修改密码', icon: 'el-icon-edit' },
      },
      {
        path: 'scenicList',
        name: 'scenicList',
        component: () => import('@/views/setup/param/scenicList'),
        meta: {
          title: '景区新增页',
          hidden: true,
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
      {
        path: 'supplierAdd',
        name: 'supplierAdd',
        component: () => import('@/views/setup/param/supplierAdd'),
        meta: {
          title: '供应商新增页',
          hidden: true,
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
      {
        path: 'depart',
        name: 'depart',
        component: () => import('@/views/market/param/depart'),
        meta: {
          title: '兑换码新增页',
          hidden: true,
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
      {
        path: 'bannerAdd',
        name: 'bannerAdd',
        component: () => import('@/views/market/param/bannerAdd'),
        meta: {
          title: 'banner新增页',
          hidden: true,
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
      {
        path: 'radioAdd',
        name: 'radioAdd',
        component: () => import('@/views/radio/param/add'),
        meta: {
          title: '电台新增页',
          hidden: true,
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
      {
        path: 'seriesAdd',
        name: 'seriesAdd',
        component: () => import('@/views/cardlist/param/seriesAdd.vue'),
        meta: {
          title: '系列新增页',
          hidden: true,
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
      {
        path: 'cardAdd',
        name: 'cardAdd',
        component: () => import('@/views/cardlist/param/cardAdd.vue'),
        meta: {
          title: '卡牌新增页',
          hidden: true,
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
      {
        path: 'cardDetail',
        name: 'cardDetail',
        component: () => import('@/views/cardlist/param/cardDetail.vue'),
        meta: {
          title: '卡牌详情页',
          hidden: true,
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
      {
        path: 'numlist',
        name: 'numlist',
        component: () => import('@/views/market/param/numlist.vue'),
        meta: {
          title: '次数列表页',
          hidden: true,
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
      {
        path: 'resultlist',
        name: 'resultlist',
        component: () => import('@/views/market/param/resultlist.vue'),
        meta: {
          title: '抽奖列表页',
          hidden: true,
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
    ]
  },


]
export const authRoutes = [
  // {
  //   path: '/datacen',
  //   name: 'datacen',
  //   component: Layout,
  //   redirect: '/datacen/index',
  //   meta: {
  //     title: '数据中心',
  //     icon: 'el-icon-folder',
  //   },
  //   children: [
  //     {
  //       path: 'order',
  //       name: 'Order',
  //       component: () => import('@/views/datacen/index'),
  //       meta: {
  //         title: '数据中心',
  //       },
  //     }
  //   ]
  // },
  {
    path: '/userlist',
    name: 'userlist',
    component: Layout,
    redirect: '/userlist/index',
    meta: {
      title: '用户管理',
      icon: 'el-icon-s-custom',
    },
    isAuth: true, // 要授权
    children: [
      {
        path: 'userlist',
        name: 'userlist',
        component: () => import('@/views/userlist/index'),
        meta: {
          title: '用户列表',
        },
        isAuth: true
      },
    ]
  },
  {
    path: '/cardlist',
    name: 'cardlist',
    component: Layout,
    redirect: '/cardlist/index',
    meta: {
      title: '卡牌管理',
      icon: 'el-icon-postcard',
    },
    isAuth: true, // 要授权
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/cardlist/index'),
        meta: {
          title: '系列管理',
        },
        isAuth: true
      },
      {
        path: 'overview',
        name: 'overview',
        component: () => import('@/views/cardlist/overview'),
        meta: {
          title: '卡牌总览',
        },
        isAuth: true
      },
    ]
  },
  {
    path: '/radiomanage',
    name: 'radiomanage',
    component: Layout,
    redirect: '/radio/radiomanage',
    meta: {
      title: '电台管理',
      icon: 'el-icon-microphone',
    },
    isAuth: true, // 要授权
    children: [
      {
        path: 'radiomanage',
        name: 'radiomanage',
        component: () => import('@/views/radio/radiomanage'),
        meta: {
          title: '电台列表',
        },
        isAuth: true
      },
      {
        path: 'radiodata',
        name: 'radiodata',
        component: () => import('@/views/radio/radio-data/index'),
        meta: {
          title: '电台数据',
        },
        isAuth: true
      },
      {
        path: 'radiosort',
        name: 'radiosort',
        component: () => import('@/views/radio/radiosort/index'),
        meta: {
          title: '电台分类',
        },
        isAuth: true
      },
    ]
  },
  {
    path: '/market',
    name: 'market',
    component: Layout,
    redirect: '/market/prize',
    meta: {
      title: '营销管理',
      icon: 'el-icon-sell',
    },
    isAuth: true, // 要授权
    children: [
      {
        path: 'prize',
        name: 'prize',
        component: () => import('@/views/market/prize'),
        meta: {
          title: '抽兑换码',
        },
        isAuth: true
      },
      
      {
        path: 'banner',
        name: 'banner',
        component: () => import('@/views/market/banner'),
        meta: {
          title: 'banner管理',
        },
        isAuth: true
      },
    ]
  },
  {
    path: '/chip',
    name: 'chip',
    component: Layout,
    redirect: '/chip/chipmanage',
    meta: {
      title: '芯片管理',
      icon: 'el-icon-cpu',
    },
    isAuth: true, // 要授权
    children: [
      {
        path: 'chipmanage',
        name: 'chipmanage',
        component: () => import('@/views/chip/chipmanage'),
        meta: {
          title: '卡牌订单',
        },
        isAuth: true
      },
    ]
  },
  {
    path: '/setup',
    name: 'setup',
    component: Layout,
    // redirect: '/chip/chipmanage',
    meta: {
      title: '设置',
      icon: 'el-icon-setting',
    },
    isAuth: true, // 要授权
    children: [
      {
        path: 'scenic',
        name: 'scenic',
        component: () => import('@/views/setup/scenic'),
        meta: {
          title: '景区管理',
        },
        isAuth: true
      },
      {
        path: 'supplier',
        name: 'supplier',
        component: () => import('@/views/setup/supplier'),
        meta: {
          title: '供应商管理',
        },
        isAuth: true
      },
      {
        path: 'version',
        name: 'version',
        component: () => import('@/views/setup/version'),
        meta: {
          title: '写码软件版本',
        },
        isAuth: true
      },
      
    ]
  },
  // {
  //   path: '/map',
  //   name: 'Map',
  //   component: Layout,
  //   redirect: '/map/mapdisplay',
  //   meta: {
  //     title: '设置',
  //     icon: 'el-icon-search',
  //   },
  //   isAuth: true, // 要授权
  //   children: [
  //     {
  //       path: 'mapdisplay',
  //       name: 'Mapdisplay',
  //       component: () => import('@/views/demo/demo6'),
  //       meta: {
  //         title: '地图展示',
  //         icon: 'el-icon-magic-stick'
  //       },
  //       isAuth: true
  //     },
  //   ]
  // },
]

export const phoneCurrencyRoutes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/phoneIndex',
    hidden: true
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: { 'title': '登录页' },
    hidden: true
  },


]

export const phoneAuthRoutes = [
  {
    path: '/phoneIndex',
    name: 'phoneIndex',
    redirect: '/phoneIndex/phoneOrder',
    component: () => import('@/views/phone/index.vue'),
    meta: {
      'title': '详情页',
    },
    children: [
      {
        path: 'phoneOrder',
        name: 'phoneOrder',
        component: () => import('@/views/phone/order.vue'),
        meta: {
          'title': '订单查询',
        },
        isAuth: false
      },
      {
        path: 'phoneStatic',
        name: 'phoneStatic',
        component: () => import('@/views/phone/static.vue'),
        meta: {
          'title': '数据统计',
        },
        isAuth: true
      }
    ]
  },
]

const creatRouter = () => {
  return new Router({
    routes: isPC() ? currencyRoutes : phoneCurrencyRoutes,
    mode: 'history',
    scrollBehavior() {
      return { x: 0, y: 0 }
    }
  })
}
const router = creatRouter()
export default router


// 导航守卫
router.beforeEach(async (to, from, next) => {
  document.title = getTitle(to.meta.title)
  if (to.path === '/login') {
    if (store.getters.token) {
      next({
        path: '/dashbord',
      })
    } else {
      next()
    }
  } else {
    if (to.query && to.query.secretkey) {
      // 这里加入从别人系统免密进入的情况
      await store.dispatch('user/_getRsa', { data: decodeURIComponent(to.query.secretkey) })
    }
    if (store.getters.token) {
      const hasRoles = store.getters.roles.length > 0
      if (hasRoles) {
        if (to.name === null) {
          next({
            path: '/404',
            query: {
              redirect: to.fullPath
            }
          })
        } else {
          next()
        }
      } else {
        try {
          const res = await store.dispatch('user/_getInfo')

          if (!res.data) {
            Message.error(res.msg)
            next({
              path: '/login',
              query: {
                redirect: to.fullPath
              }
            })
          } else {
            // console.log(res.data.MenuList);
            // 把有权限的路由进行过滤
            const authorizedRoutes = res.data.MenuList;
            // 改写authorizedRoutes
            let tempAuthorizedRoutes = [];
            for (let val of authorizedRoutes) {
              tempAuthorizedRoutes.push(val.name)
            }
            const allRoutes = isPC() ? authRoutes : phoneAuthRoutes;
            const authMenu = filterAuthorizedRoutes(allRoutes, tempAuthorizedRoutes);
            // const authMenu = authRoutes
            router.addRoutes(authMenu); // 把有权限的路由添加进去
            // console.log(router.getRoutes())
            if (isPC()) {
              store.commit('permission/SET_ROUTES', authMenu); // 把获取到的路由列表更新到store中，routes后期需要增加过滤的
              localStorage.setItem('routes', JSON.stringify(authMenu)) // 防止用户刷新页面，存入到本地缓存中
               next({ ...to, replace: true })
            } else {
              localStorage.setItem('routes', JSON.stringify(phoneAuthRoutes)) // 防止用户刷新页面，存入到本地缓存中
              if (to.path == "/phoneIndex") {
                const name = phoneAuthRoutes[0].children[0].path
                router.push({
                  path: `/phoneIndex/${name}`,
                })
              }else{
                next({ ...to, replace: true })
              }
            }
          }
        } catch (error) {
          Message.error(error)
        }
      }

    } else {
      console.log(to)
      next({
        path: '/login',
        query: {

        }
      })
    }
  }
})

